<form [formGroup]="EmailForm" (ngSubmit)="Submit(EmailForm)" novalidate>
    <h1 mat-dialog-title>Email Judges</h1>
    <div mat-dialog-content>
        <p>
            Please select an award and a judging phase.
            This tool will notify all judges for that award in that phase that they are judges.
            It will send them their judging key and instructions about logging in.
        </p>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Nominee Type</span></div>
            <mat-form-field appearance="outline">
                <mat-select formControlName="NomineeTypeID" placeholder="Select nominee type...">
                    <mat-option [value]="null">Select nominee type...</mat-option>
                    <mat-option *ngFor="let nt of NomineeTypes" [value]="nt.NomineeTypeID">{{nt.Description}}</mat-option>
                </mat-select>
                <mat-error *ngIf="EmailForm.get('NomineeTypeID')?.hasError('required')">required</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Judging Phase</span></div>
            <mat-form-field appearance="outline">
                <mat-select formControlName="JudgingPhase" placeholder="Select phase...">
                    <mat-option [value]="null">Select phase...</mat-option>
                    <mat-option *ngFor="let phase of Phases" [value]="phase.Value">{{phase.Display}}</mat-option>
                </mat-select>
                <mat-error *ngIf="EmailForm.get('JudgingPhase')?.hasError('required')">required</mat-error>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">Cancel</button>
        <button mat-raised-button type="submit" [color]="'primary'">Submit</button>
    </div>
</form>